import { render } from "./Tarif_Course_Item.vue?vue&type=template&id=d3c5a00a"
import script from "./Tarif_Course_Item.vue?vue&type=script&lang=js"
export * from "./Tarif_Course_Item.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__